<ng-container *ngIf="noticias?.length > 0">
  <ng-container *ngFor="let noticia of noticias">
    <div class="contenedor-directo" [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
      <div class="desktop-noticia-container">
        <div class="desktop-noticia-container">
          <app-skeleton-image [customClass]="'desktop-noticia-imagen'" [alt]="noticia.tituloVideo" [src]="'/assets/images/banner-carta-director.webp'" [lazy]="false" [height]="100" [isPriority]="true" [isFill]="true" [size]="980" [aspectRatio]="1250 / 94"></app-skeleton-image>
          <div class="desktop-noticia-text">
            <h2 class="desktop-noticia-directo">
              <a [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
                {{ noticia?.tituloVideo }}
              </a>
            </h2>
          </div>
        </div>
      </div>
      <div class="mobile-noticia-container">
        <app-skeleton-image [customClass]="'noticia-imagen'" [alt]="noticia.tituloVideo" [src]="'/assets/images/banner-carta-director-movil.webp'" [lazy]="false" [height]="100" [isPriority]="true" [isFill]="true" [size]="400" [aspectRatio]="55 / 55"></app-skeleton-image>
        <h2 class="noticia-directo">
          <a [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
            {{ noticia?.tituloVideo }}
          </a>
        </h2>
      </div>
    </div>
  </ng-container>
</ng-container>
